import { useContext } from "react";
import { AlertContext } from "./AlertContext";

const useAlertState = () => {
  return useContext(AlertContext);
};

export default useAlertState;
